module.exports = __webpack_public_path__ + "img/PY.4f675a58.webp";